const homesideOrange = '#fd7a40';

const palette = {
  grey100: '#e0e0e0',
  grey200: '#aeaeb1',
  grey300: '#7c7c81',
  grey400: '#666666',
  grey600: '#00023f',
  grey700: '#181b31',
  orange: homesideOrange,
  placeholder: homesideOrange,
};

const colors = {
  active: palette.placeholder,
  black: '#000000',
  currentSession: palette.grey300,
  error: '#fc4c6c',
  form: palette.placeholder,
  homeAuto: palette.placeholder,
  hover: '#fd8c40',
  info: '#fd7a40',
  mortgage: palette.placeholder,
  primary: palette.orange,
  realEstate: palette.placeholder,
  savings: palette.placeholder,
  secondary: palette.grey700,
  text: palette.grey300,
  textDarker: palette.grey400,
  transparentPrimary: palette.placeholder,
  white: '#ffffff',
};

export {
  palette, colors,
};
